import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { TherapeuticType } from '../models/therapeutic';

@Injectable({
  providedIn: 'root'
})
export class TherapeuticService extends BaseService {
  getTherapeuticClass(type: TherapeuticType,
    class1: string,
    class2: string,
    class3: string,
    onSuccess: (data) => void,
    onError: (data) => void = null): any {
    const apiUrl = this.getTherapeuticApi(type, class1, class2, class3);
    this.get(apiUrl)
      .subscribe(
        resp => {
          onSuccess(resp.data);
        },
        err => {
          if (onError) {
            onError(err);
          }
        });
  }

  getTherapeuticApi(type: TherapeuticType, class1: string, class2: string, class3: string): string {
    let apiUrl = 'therapeutic/class1';
    if (type === TherapeuticType.CLASS2) {
      apiUrl = `therapeutic/class2?class1=${class1}`;
    } else if (type === TherapeuticType.CLASS3) {
      apiUrl = `therapeutic/class3?class1=${class1}&class2=${class2}`;
    } else if (type === TherapeuticType.CLASS4) {
      apiUrl = `therapeutic/class4?class1=${class1}&class2=${class2}&class3=${class3}`;
    }

    return apiUrl;
  }
}
